export default "__VITE_ASSET__C_ysHK62__"